export enum ContactCategory {

  DEBTOR = 'DEBTOR',
  CREDITOR = 'CREDITOR',
  EMPLOYEE = 'EMPLOYEE',
  COMPANY_CONTACT = 'COMPANY_CONTACT',
  // Only available for relations or deaths
  PERSON = 'PERSON',
  // Only available for funeral (death) feature
  MEDICAL = 'MEDICAL'
}
